module.exports = __webpack_public_path__ + "components/country-flag/static/km-8b80906fb7e0d0e52fbb20c3fd0f81ff.svg";